import React from "react";
import { Layout } from "@/components/Layout";
import { PageHeader } from "@/components/PageHeader";

const STATS = [
  ["120+", "Destinations curated"],
  ["50k", "Plans crafted"],
  ["24/7", "Concierge on call"],
  ["4.9", "Member rating"],
];

const About = () => (
  <Layout>
    <PageHeader
      eyebrow="About"
      title="One concierge. Every part of life."
      subtitle="MOVA brings travel, fashion, self-care and everyday living into a single, considered experience."
      image="https://images.unsplash.com/photo-1561501900-3701fa6a0864?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000"
    />

    <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-testid="about-content">
      <p className="font-serif text-2xl sm:text-3xl text-white leading-relaxed">
        We believe a well-lived life shouldn't require a dozen apps and endless tabs.
      </p>
      <p className="text-slate-400 mt-6 leading-relaxed text-lg">
        MOVA is your complete lifestyle concierge — blending human taste with intelligent planning. Plan luxury trips, shop the brands you love, book restorative self-care and keep your goals and budget in effortless order. Everything curated, everything in one place.
      </p>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mt-16">
        {STATS.map(([v, l]) => (
          <div key={l} className="rounded-2xl border border-white/10 bg-[#101017] p-6 text-center">
            <p className="font-serif text-3xl gold-gradient-text">{v}</p>
            <p className="text-xs text-slate-400 mt-2">{l}</p>
          </div>
        ))}
      </div>
    </section>
  </Layout>
);

export default About;
